import { Component } from '@angular/core';

@Component({
  selector: 'app-unimplemented',
  standalone: true,
  imports: [],
  templateUrl: './unimplemented.component.html',
  styleUrl: './unimplemented.component.css'
})
export class UnimplementedComponent {

}
